import { Component, OnInit } from '@angular/core';
import { MembershipFormData, Leadership, Site } from "../../bpg-common/services/data.services";

import { Router } from '@angular/router';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';

@Component({
  selector: 'app-bpg-leadership',
  templateUrl: './bpg-leadership.component.html',
  styleUrls: ['./bpg-leadership.component.css']
})
export class BpgLeadershipComponent implements OnInit {

  skillsList: any[];
  savedData: any = JSON.parse(sessionStorage.getItem('MembershipData'));
  interestList: any[];
  bpgList: any[];
  siteList: Site;
  chair: boolean;
  voiceChair: boolean;
  communicationsChair: boolean;
  financeChair: boolean;
  formData: MembershipFormData[];
  selectedLeadership: Leadership = new Leadership();
  demographicsList: any[] = [];
  otherSKills: string;
  savedMembershipForm: any = JSON.parse(sessionStorage.getItem('previousMembershipDetails'));

  /** @class BpgLeadershipComponent
   * @constructor
   */
  constructor(
    private readonly router: Router,
    private readonly environment : EnvironmentConfiguration
) { }

  ngOnInit() {

  if(this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod'){
   if(localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined ){
      this.router.navigate(['/log-out']);
    }
  }
    this.chair = null;
    this.voiceChair = null;
    this.communicationsChair = null;
    this.financeChair = null;
    this.formData = [];

    if (this.savedData[0].siteFormData !== undefined) {
      this.siteList = this.savedData[0].siteFormData;
    } else {
      this.siteList = undefined;
    }
    if (this.savedData[0].interestFormData !== undefined) {
      this.interestList = this.savedData[0].interestFormData;
    } else {
      this.interestList = [];
    }
    if (this.savedData[0].bpgFormData !== undefined) {
      this.bpgList = this.savedData[0].bpgFormData;
    } else {
      this.bpgList = [];
    }
    if (this.savedData[0].skillsFormData !== undefined) {
      this.skillsList = this.savedData[0].skillsFormData;
    } else {
      this.skillsList = [];
    }

    if (this.savedData[0].otherSkillsFormData !== undefined) {
      this.otherSKills = this.savedData[0].otherSkillsFormData;
    } else {
      this.otherSKills = null;
    }


    if (this.savedData[0].leadershipFormData !== undefined) {
      if (this.savedData[0].leadershipFormData.chair !== undefined) {
	this.chair = this.savedData[0].leadershipFormData.chair;
      }
      if (this.savedData[0].leadershipFormData.viceChair !== undefined) {
	this.voiceChair = this.savedData[0].leadershipFormData.viceChair;
      }
      if (this.savedData[0].leadershipFormData.communicationsChair !== undefined) {
	this.communicationsChair = this.savedData[0].leadershipFormData.communicationsChair;
      }
      if (this.savedData[0].leadershipFormData.financeChair !== undefined) {
	this.financeChair = this.savedData[0].leadershipFormData.financeChair;
      }
    }
    else if (this.savedMembershipForm.leadershipDetails != null) {
      this.chair = this.savedMembershipForm.leadershipDetails.isChair;
      this.voiceChair = this.savedMembershipForm.leadershipDetails.isViceChair;
      this.communicationsChair = this.savedMembershipForm.leadershipDetails.isCommunicationChair;
      this.financeChair = this.savedMembershipForm.leadershipDetails.isFinanceChair;

    }


  }

  /** To send data to next page
   * @class BpgLeadershipComponent
   * @method saveData
   */
  public saveData() {
    this.selectedLeadership.chair = this.chair;
    this.selectedLeadership.viceChair = this.voiceChair;
    this.selectedLeadership.communicationsChair = this.communicationsChair;
    this.selectedLeadership.financeChair = this.financeChair;
    this.formData.push({ virtualBpg: this.savedData[0].virtualBpg, siteFormData: this.siteList, bpgFormData: this.bpgList, interestFormData: this.interestList, skillsFormData: this.skillsList, leadershipFormData: this.selectedLeadership, otherSkillsFormData: this.otherSKills });

    sessionStorage.setItem("MembershipData",JSON.stringify(this.formData));
    window.scrollTo(0, 0)
  }

  /** To send data to previous page
   * @class BpgLeadershipComponent
   * @method redirectToBpg
   */
  public redirectToBpg() {
    this.selectedLeadership.chair = this.chair;
    this.selectedLeadership.viceChair = this.voiceChair;
    this.selectedLeadership.communicationsChair = this.communicationsChair;
    this.selectedLeadership.financeChair = this.financeChair;
    this.formData.push({ virtualBpg: this.savedData[0].virtualBpg, siteFormData: this.siteList, bpgFormData: this.bpgList, interestFormData: this.interestList, skillsFormData: this.skillsList, leadershipFormData: this.selectedLeadership, otherSkillsFormData: this.otherSKills });

   sessionStorage.setItem("MembershipData",JSON.stringify(this.formData));
    window.scrollTo(0, 0)
  }

  /**skips the selected data and goes to next page
   * @class BpgLeadershipComponent
   * @method skipLeadership
   */
  public skipLeadership() {
    this.formData.push({ virtualBpg: this.savedData[0].virtualBpg, siteFormData: this.siteList, bpgFormData: this.bpgList, interestFormData: this.interestList, skillsFormData: this.skillsList, leadershipFormData: null, otherSkillsFormData: this.otherSKills });

   sessionStorage.setItem("MembershipData",JSON.stringify(this.formData));
    window.scrollTo(0, 0)
  }

}
